import React from 'react'
import { useNavigate } from 'react-router'

import PrimaryButton from '@lyrahealth-inc/ui-core/lib/atoms/buttons/primaryButton/PrimaryButton'
import BootstrapContainer from '@lyrahealth-inc/ui-core/lib/molecules/layouts/bootstrapContainer/BootstrapContainer'
import CardSmall from '@lyrahealth-inc/ui-core/lib/molecules/layouts/cardSmall/CardSmall'

import styles from './forbiddenRoute.module.scss'

export default () => {
  const navigate = useNavigate()
  return (
    <BootstrapContainer>
      <CardSmall>
        <div className={styles['forbidden-container']}>
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          <h1>You don't have the required permissions to view this page.</h1>
          <PrimaryButton id='test-forbiddenroute-click' onClick={() => navigate('/')}>
            Return Home
          </PrimaryButton>
        </div>
      </CardSmall>
    </BootstrapContainer>
  )
}
